import 'jsrender';
import { DetectIE } from 'Utils/device-utils';

/* jQuery plugin widgetMoreItems
*  required: jQuery, jsRender
*  
*  Documentation of jsRender API: https://www.jsviews.com/#jsrapi
*  Examples of jsRender: https://www.jsviews.com/#download/pages-jsr-jq
*  
*/
/* Example html:
 <div class="widgetMoreItems widgetReviewsBoxes" data-items="@(@Model.ElementId)" data-type="destination-reviews" data-page-id="@Model.PageId">
 </div>
    @* pre-loaded 1st pagination (options.deferLoad: false) *-@
    AppData.widgetMoreItems['@(@Model.ElementId)'] = {
        ItemsCount: @(Model.ReviewCount),
        Items: @Html.Raw(Newtonsoft.Json.JsonConvert.SerializeObject(Model.Items)),
        ListOptions: @Html.Raw(Newtonsoft.Json.JsonConvert.SerializeObject(Model.DefaultListSettings)),
    };*@

    @*deffer load 1st pagination (options.deferLoad: true) *@
    AppData.widgetMoreItems['@(@Model.ElementId)'] = {
        ItemsCount: @(Model.DefaultListSettings.NextCount),
        Items: [],
        ListOptions: {
            LastCount: 0,
            NextCount: @(Model.DefaultListSettings.NextCount),
            TotalItems: @(Model.DefaultListSettings.TotalItems),
        }
    };
 */
(function ($) {
    var slice = Array.prototype.slice; // save ref to original slice()
    var splice = Array.prototype.splice; // save ref to original splice()

    var TemplateName = {
        item: "actionbox_item",
        moreItems: "btn-more-container"
    };

    //function GetBreakpointWidth() {
    //    //var bp_Width = $(window).width();
    //    var bp_Width = window.innerWidth > 0 ? window.innerWidth : window.screen.width;
    //    return bp_Width;
    //}

    //function GetBreakpointHeight() {
    //    //var bp_Height = $(window).height();
    //    var bp_Height = window.innerHeight > 0 ? window.innerHeight : window.screen.height;
    //    return bp_Height;
    //}

    function init_templates(actionbox) {
        var actionboxElement = actionbox.actionboxElement;
        let init_template = function (templateName, allowCode) {
            let $template = actionboxElement.find('[data-template="' + templateName + '"]');
            //let tmpl = $.templates($template.html());   // Get compiled template

            let tmpl = $.templates({
                markup: $template.html(),
                allowCode: allowCode,
            });

            actionbox.templates[templateName] = $template;
            $template.detach();

            actionbox.tmpl[templateName] = tmpl;
        };

        init_template(TemplateName.item, true);
        //init_template(TemplateName.moreItems, true);
    }

    function init_slider(actionbox) {
        var actionboxElement = actionbox.actionboxElement,
            $holder = actionboxElement.find('.' + actionbox.holderClassName),
            $slider = actionbox.$slider;

        update_lazysizes($slider);

        $holder.hide();
        $slider.show();
        actionbox.$holder = $holder;
        $holder.detach();

        update_slimmage();
        update_moreButton(actionbox);
    }

    function destroy_slider(actionbox) {
        let actionboxElement = actionbox.actionboxElement,
            $holder = actionboxElement.find('.' + actionbox.holderClassName),
            $moreButton = actionbox.$moreButton,
            $slider = actionbox.$slider;
        if ($holder.length < 1 && actionbox.$holder) {
            $holder = actionbox.$holder;
            $holder.appendTo(actionboxElement);
        }

        if ($moreButton.length < 1 && actionbox.$moreButton) {
            $moreButton = actionbox.$moreButton;
            $moreButton.css("display", "none");
        }

        $slider.hide();
        $holder.show();

        $slider.empty();
    }

    function update_lazysizes($slider) {
        let $images = $slider.find('img, .lazyload');
        if ($images && $images.length > 0) {
            $images.each(function (i, el) {
                if (el.hasClass('lazydefer')) {
                    el.removeClass('lazydefer');
                }
                el.style.removeProperty('visibility');
                el.style.removeProperty('display');
            });
        }
    }

    function update_slimmage() {
        if (window.slimmage.checkResponsiveImages) {
            window.slimmage.checkResponsiveImages();
        }

        if (typeof imgix !== "undefined") {
            imgix.init();
        }

        if (typeof lazySizes !== "undefined") {
            lazySizes.loader.checkElems();
        }
    }

    function update_moreButton(actionbox) {
        let actionboxElement = actionbox.actionboxElement;
        if (!actionbox.$moreButton) {
            actionbox.$moreButton = actionboxElement.find('.' + actionbox.moreButtonClassName);
        }
        let $moreButton = actionbox.$moreButton;
        let listOptions = actionbox.request.data.ListOptions;

        /// more-btn if totalItems more last-count
        if (listOptions.TotalItems > listOptions.LastCount) {
            $moreButton.css("display", "block");
        } else {
            $moreButton.css("display", "none");
        }
    }

    function requestData(actionbox) {
        if (!actionbox)
            return;

        if (!actionbox.request)
            actionbox.request = {};

        if (actionbox.request.requesting) {
            // cancel new request while executing prev.request
            return;
        }


        var jqxhr = actionbox.request.jqxhr;
        if (jqxhr) {
            // cancel executing request before start new request 
            //if (typeof jqxhr.abort != "undefined")
            //    jqxhr.abort();

            // cancel new request while executing prev.request
            return;
        }

        actionbox.request.requesting = true;
        actionbox.request.failed = false;
        actionbox.request.ready = false;

        let listOptions = actionbox.request.data.ListOptions;

        var js = actionbox.request.parameters;
        js.skip =  listOptions.LastCount;
        js.size =  listOptions.NextCount;
        js.totalItems =  listOptions.TotalItems;
        var jsondata = JSON.stringify(js);

        jqxhr = $.ajax({
            url: actionbox.request.url,
            type: actionbox.request.type, //'POST',
            data: jsondata,
            contentType: 'application/json',
            headers: { 'Accept': 'application/json' },
            success: function (data) {
                if (data && data.Redirect && data.RedirectUrl != '') {
                    if (typeof ga != "undefined") {
                        ga('send', 'event', 'widget MoreItems ', 'Redirected', 'GetRequestDetailsByParams()');
                    }
                    //window.location.href = data.RedirectUrl;
                    window.location = data.RedirectUrl;
                    return;
                }

                var success = false;
                actionbox.request.data = data;
                if (!data || data.length == 0) {
                    actionbox.request.ready = false;
                    actionbox.request.failed = true;
                    actionbox.request.requesting = false;
                } else {
                    if (typeof data.Success != "undefined") {
                        success = data.Success; // use Success if this property exists
                    } else {
                        success = true; // keep previous logic-way
                    }
                    
                    actionbox.request.failed = false;
                    actionbox.request.ready = true;
                    actionbox.request.requesting = false;
                }
                if (success) {
                    if (actionbox.deferLoad && !actionbox.inited) {
                        init_templates(actionbox);
                        init_slider(actionbox);
                        actionbox.inited = true;
                    }
                    //init_templates(actionbox);
                    updateWithData(actionbox, true);
                    //init_slider(actionbox);
                    
                }

                if (typeof actionbox.request.callback == "function")
                    actionbox.request.callback(success);
            },
            error: function (data, textStatus, errorThrown) {
                actionbox.request.data = data;
                actionbox.request.ready = false;
                actionbox.request.failed = true;
                actionbox.request.requesting = false;

                if (typeof actionbox.request.callback == "function")
                    actionbox.request.callback(false);
            }
        }).always(function () {
            actionbox.request.jqxhr = null;
        });
        actionbox.request.jqxhr = jqxhr;
    }

    function updateWithData(actionbox, forceLazyload) {
        //console.log('updateWithData', actionbox);

        var //actionboxElement = actionbox.actionboxElement,
            $slider = actionbox.$slider;

        var tmpl = actionbox.tmpl[TemplateName.item];
        var items = actionbox.request.data.Items;

        let num = 0;
        items.forEach(function (item, i) {
            let $col = $('<div></div>')
                .addClass('col-12 col-sm-6 col-md-4 col-lg-4');
            num += (i + 1);
            if (i>1) $col.addClass('d-sm-none d-md-block'); 
            let html = tmpl.render(item, actionbox.helpers);
            $col.html(html);
            $col.attr('data-num', num);

            $slider.append($col);
        });

        if (forceLazyload) {
            update_lazysizes($slider);
            update_slimmage();
        }

        update_moreButton(actionbox);
    }


    var defaults = {
        sliderClassName: 'slider',
        holderClassName: 'holder',
        request: {
            url: '',
            type: 'GET',
            parameters: null,
            //jqxhr: null,
            //data: data,
            //ready: false,
            //failed: false,
            //requesting: false
        },
        deferLoad: false,
        moreButtonClassName: 'btn-more-container',
        moreItemsLoadClassName: 'more-items-load',
        templates: {},
        tmpl: {}
    },
        //$window = $(window),
        //$document = $(document),
        actionboxs = [],
        //scroller = function () {
        //    //console.log('actionbox-slider scroller()');
        //},
        //resizer = function () {
        //    //console.log('actionbox-slider resizer()');
        //    //for (var i = 0, l = actionboxs.length; i < l; i++) {
        //    //    var s = actionboxs[i];
        //    //    //update_slider(s);
        //    //    update_slides(s);
        //    //}
        //    //update sidebar after resize
        //    scroller();
        //},
        methods = {
            init: function (options) {
                return this.each(function () {
                    var o = $.extend({}, defaults, options);
                    var actionboxElement = $(this);

                    var actionboxId = actionboxElement.attr('id');
                    var sliderId = actionboxId ? actionboxId + '-' + o.sliderClassName : o.sliderClassName;
                    var $slider = $('<div></div>')
                        .attr('id', sliderId)
                        .css('display', 'none')
                        .addClass('row')
                        .addClass(o.sliderClassName);
                    actionboxElement.prepend($slider);

                    var flgIE = DetectIE() !== false;
                    if (flgIE) {
                        actionboxElement.addClass('IE');
                    }

                    let $moreButton = actionboxElement.find('.' + o.moreButtonClassName);
                    let $btnLoad = $moreButton.hasClass(o.moreItemsLoadClassName) ? $moreButton : $moreButton.find('.' + o.moreItemsLoadClassName);
                    $btnLoad.on('click', function (e) {
                        requestData(o);
                        $btnLoad.blur();
                    });
                    o.$moreButton = $moreButton;

                    let deferredLoad = false;
                    let data = null;
                    let attrItems = actionboxElement.attr('data-items');
                    if (attrItems && attrItems.length > 0) {
                        data = window.AppData.widgetMoreItems[attrItems];
                    }

                    if (o.deferLoad && o.request && o.request.url.length > 0 && o.request.parameters) {
                        if (!o.request.data && data) {
                            o.request.data = data;
                        }
                        if (o.request.data) {
                            requestData(o);
                            deferredLoad = true;
                        }
                    }

                    if (!deferredLoad) {
                        if (!o.request)
                            o.request = {};

                        if (data)
                            o.request.data = data;
                        
                        // emulate success/error callback(s) of request
                        setTimeout(function () {
                            if (o.request.data) {
                                // success
                                o.request.failed = false;
                                o.request.ready = true;
                                o.request.requesting = false;
                                init_templates(o);
                                updateWithData(o);
                                init_slider(o);
                                o.inited = true;
                            } else {
                                // error
                                o.request.ready = false;
                                o.request.failed = true;
                                o.request.requesting = false;
                            }
                        }, 64);
                    }

                    o.actionboxElement = actionboxElement;
                    o.$slider = $slider;
                    actionboxs.push(o);
                });
            },
            //update: function () {
            //    scroller.apply(this, arguments);
            //},
            destroy: function (options) {
                return this.each(function () {
                    var that = this;
                    var unactionboxElement = $(that);

                    var removeIdx = -1;
                    var i = actionboxs.length;
                    while (i-- > 0) {
                        if (actionboxs[i].actionboxElement.get(0) === that) {
                            //methods.destroySlider(actionboxs[i]);
                            destroy_slider(actionboxs[i]);
                            actionboxs[i].$slider.remove();
                            actionboxs[i].$slider = null;
                            actionboxs[i].$holder = null;
                            //actionboxs[i].templates = {};
                            //unactionboxElement.removeClass(actionboxs[i].elementClassName);
                            splice.call(actionboxs, i, 1);
                            removeIdx = i;
                        }
                    }
                    if (removeIdx !== -1) {
                        // TODO smth with unactionboxElement styles on destroy
                        //unactionboxElement.unwrap();
                        //unactionboxElement.css({
                        //    'width': '',
                        //    'position': '',
                        //    'top': '',
                        //    'float': '',
                        //    'z-index': ''
                        //});
                    }
                });
            }
        };

    //// should be more efficient than using $window.scroll(scroller) and $window.resize(resizer):
    //if (window.addEventListener) {
    //    window.addEventListener('scroll', scroller, false);
    //    window.addEventListener('resize', resizer, false);
    //} else if (window.attachEvent) {
    //    window.attachEvent('onscroll', scroller);
    //    window.attachEvent('onresize', resizer);
    //}

    $.fn.widgetMoreItems = function (method) {
        if (methods[method]) {
            return methods[method].apply(this, slice.call(arguments, 1));
        } else if (typeof method === 'object' || !method) {
            return methods.init.apply(this, arguments);
        } else {
            $.error('Method ' + method + ' does not exist on widgetMoreItems');
        }
    };

    //$(function () {
    //    setTimeout(scroller, 0);
    //});
})(jQuery);


/*
widgetMoreItems
*/
//AppLoader.ready(function () {
$(document).ready(function () {
    // added some timeout to give time for processing things with higher priorities.
    setTimeout(function () {
        if ($('.widgetMoreItems').length > 0) {
            var c = 0;
            $('.widgetMoreItems').each(function () {
                var $this = $(this);
                var id = $this.attr('id');
                if (!id || id == '') {
                    $this.attr('id', 'widgetMoreItems-' + c);
                    //$this.attr('id', 'wmi-' + c);
                    c++;
                }
            });

            
            $('.widgetMoreItems[data-items][data-type="destination-reviews"]').widgetMoreItems({
                sliderClassName: 'widget-more-items',
                holderClassName: 'placeholder',
                moreButtonClassName: 'btn-more-container',
                moreItemsLoadClassName: 'more-items-load',
                request: {
                    url: '/widgets-api/destination-reviews',
                    type: 'POST',
                    parameters: {
                        pageId: AppData.CurrentPageId
                    }
                },
                deferLoad: false,
                helpers: {
                    hasHeadline: function (destinationReview) {
                        if (!destinationReview)
                            return false;

                        let text = destinationReview.Headline;
                        return text && text != "" && text.length > 0;
                    },
                    hasBody: function (destinationReview) {
                        if (!destinationReview)
                            return false;
                        let text = destinationReview.ShortBody;
                        return text && text != "" && text.length > 0;
                    },
                    dots: function (destinationReview) {
                        //if (!destinationReview)
                        //    return '';

                        //let text1 = destinationReview.ShortBody;
                        //if (!(text1 && text1 != "" && text1.length > 0))
                        //    return '';

                        //let text2 = destinationReview.ShortBody;
                        //if (!(text2 && text2 != "" && text2.length > 0))
                        //    return '';

                        //return text2.length > text1.length ? '&hellip;' : '';
                        return "";
                    },
                    hasDestinationLink: function (destinationReview) {
                        if (!destinationReview)
                            return false;

                        if (!destinationReview.DestinationLink)
                            return false;

                        if (!window.AppData.CurrentPageId)
                            return false;

                        if (!destinationReview.DestinationPageId)
                            return false;

                        return destinationReview.DestinationPageId !== window.AppData.CurrentPageId;
                    }
                }
            });

            //$('.widgetMoreItems[data-items][data-type="hotel-reviews"]').widgetMoreItems({
            //    sliderClassName: 'widget-more-items',
            //    holderClassName: 'placeholder',
            //    moreButtonClassName: 'btn-more-container',
            //    moreItemsLoadClassName: 'more-items-load',
            //    request: {
            //        url: '/widgets-api/hotel-reviews',
            //        type: 'POST',
            //        parameters: {
            //            pageId: AppData.CurrentPageId
            //        }
            //    },
            //    deferLoad: false,
            //    helpers: {
            //    }
            //});
        }
    }, 500);
});
